import { Box, Button, Link, Paper, Typography } from "@mui/material";

export function PageNotFound(){
    return (
        <Box
        sx={{
          marginTop: '15em',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          minHeight: "50vh",
          width: "100%",
        }}
      >
        <img src="/logo.png" alt="Logo" style={{ height: "7em", width: "14em" }} />
        <Typography variant="h1">404</Typography>
        <Typography variant="h6">The page you're looking for doesn't exist.</Typography>
        <br/><br/>
        <Link href="/" underline="none">
          <Button variant="contained">Back Home</Button>
        </Link>
      </Box>
    )
}